import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class BackgroundVideoService {

  	public isPlaying: boolean
	public isPlaying$: BehaviorSubject<boolean>;

	constructor() {
	    this.isPlaying = true
	    this.isPlaying$ = new BehaviorSubject(true);
	}

    setPlay() {
        if(!this.isPlaying) {
            this.play()
        }
    }

	play() {
	    this.isPlaying = true
	    this.isPlaying$.next(this.isPlaying)
	}

	pause() {
	    this.isPlaying = false
	    this.isPlaying$.next(this.isPlaying)
	}

    

	togglePlay() {
	    this.isPlaying = !this.isPlaying
	    this.isPlaying$.next(this.isPlaying)
	}
}
